import { staticRoutesWithSidebar } from 'Deer/constants/routes';
import { matchPath, useLocation } from 'react-router-dom';

export const useIsStaticRouteWithSidebar = () => {
  const location = useLocation();

  const matchedRoute = staticRoutesWithSidebar.find((route) =>
    matchPath(location.pathname, { path: route, exact: false })
  );

  return matchedRoute;
};
